/** @format */

import { useState, useEffect } from "react";
import { getVendorSettings, setVendorData } from "../../../services/helper";
import { toast } from "react-toastify";
import http from "../../../services/http";
import PrintOptionSettings from "./PrintSettings";

const PrinterSettingsPage = () => {
  const [settings, setSettings] = useState({
    receipt_print_option: "always",
    label_print_option: "always",
    report_print_option: "always",
    receiptTemplate: {
      showStoreName: false,
      showStorePhone: false,
      showSocialMedia: false,
      showStoreEmail: false,
      showStoreLogo: false,
      headerNote: "",
      footerNote: "",
    },
  });

  useEffect(() => {
    async function loadSettings() {
      try {
        setSettings({
          receipt_print_option:
            getVendorSettings("receipt_print_option") || "always",
          label_print_option:
            getVendorSettings("label_print_option") || "always",
          report_print_option:
            getVendorSettings("report_print_option") || "always",
          receiptTemplate: getVendorSettings("receiptTemplate") || {
            showStoreName: false,
            showStorePhone: false,
            showSocialMedia: false,
            showStoreEmail: false,
            showStoreLogo: false,
            headerNote: "",
            footerNote: "",
          },
        });
      } catch (error) {
        console.error("Error loading printer settings:", error);
        toast.error("Could not load printer settings.");
      }
    }
    loadSettings();
  }, []);

  const handleSubmit = async (updatedSettings) => {
    try {
      await http.saveVendorData({ ...updatedSettings });
      toast.success("Printer settings saved successfully!");
      setVendorData(updatedSettings);
    } catch (error) {
      console.error("Error saving printer settings:", error);
      toast.error("Failed to save printer settings. Please try again.");
    }
  };

  return (
    <div>
      <PrintOptionSettings
        settings={settings}
        onSettingsChange={(newSettings) => {
          setSettings(newSettings);
          handleSubmit(newSettings);
        }}
      />
    </div>
  );
};

export default PrinterSettingsPage;
